import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { UserX, UserCheck } from 'lucide-react';
import { adminUsuariosAPI } from '../../utils/adminUsuariosAPI';
import { sucessoComHorario } from '../../utils/toastComHorario';
import ModalRodape from './ModalRodape';

// Mesma ideia do ConfirmarStatusEnqueteModal: desativar/reativar acesso de
// usuário, sempre reversível, sempre com confirmação em modal (nunca
// window.confirm). As proteções de verdade (não desativar a si mesmo, não
// desativar o último admin) são do backend — aqui só repassamos o erro.
const ConfirmarStatusUsuarioModal = ({ usuario, acao, onFechar, onConfirmado }) => {
  const [enviando, setEnviando] = useState(false);
  const desativando = acao === 'desativar';

  const confirmar = async () => {
    setEnviando(true);
    try {
      if (desativando) {
        await adminUsuariosAPI.desativar(usuario.id);
        sucessoComHorario(`"${usuario.nome_completo}" desativado`);
      } else {
        await adminUsuariosAPI.reativar(usuario.id);
        sucessoComHorario(`"${usuario.nome_completo}" reativado`);
      }
      onConfirmado();
      onFechar();
    } catch (error) {
      toast.error(error.userMessage || 'Erro ao atualizar o usuário');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className={`flex items-start gap-3 rounded-xl p-4 ${desativando ? 'bg-amber-50' : 'bg-emerald-50'}`}>
        {desativando ? (
          <UserX className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        ) : (
          <UserCheck className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
        )}
        <div className="text-sm">
          <p className="font-medium text-gray-900">"{usuario.nome_completo}"</p>
          <p className="text-gray-600 mt-1">
            {desativando
              ? 'Perde acesso ao painel imediatamente. Pode reativar quando quiser, na aba "Desativados".'
              : 'Recupera o acesso ao painel imediatamente, com a mesma senha e tipo de antes.'}
          </p>
        </div>
      </div>

      <ModalRodape>
        <button
          onClick={onFechar}
          className="text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg px-4 py-2.5 transition-colors"
        >
          Cancelar
        </button>
        <button
          onClick={confirmar}
          disabled={enviando}
          className={`font-medium text-sm px-4 py-2.5 rounded-lg transition-colors disabled:opacity-50 ${
            desativando
              ? 'bg-amber-600 hover:bg-amber-700 text-white'
              : 'bg-emerald-600 hover:bg-emerald-700 text-white'
          }`}
        >
          {enviando ? 'Aguarde...' : desativando ? 'Desativar' : 'Reativar'}
        </button>
      </ModalRodape>
    </div>
  );
};

export default ConfirmarStatusUsuarioModal;
